import { fade } from "@material-ui/core/styles/colorManipulator";

const styles = (theme) => ({
  headerIconStyles: {
    padding: "10px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: "pointer",
  },
  toggledMenu: {
    display: "inline",
  },
  mainMenu: {
    background: theme.gridBGColor,
    borderRadius: "0px 0px 4px 4px",
    marginTop: "30px",
    overflow: "inherit",
  },
  mainMenuStyle: {
    display: "block",
    padding: "12px 0px",
    width: "220px",
  },
  mainMenuButton: {
    padding: "9px",
    color: theme.HeaderSelectedText,
  },
  toggleAnimationButton: {
    float: "left",
    cursor: "pointer",
    padding: "3px 0px",
    display: "flex",
    alignItems: "center",
  },
  toggleAnimationButtonDispatchMap: {
    float: "left",
    cursor: "pointer",
    padding: "3px 8px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      padding: "3px 8px",
    },
  },
  headerButtonContainer: {
    padding: "6px 10px",
  },
  iconLayout: {
    float: "left",
    color: theme.iconColor,
    "&>span": {
      padding: "10px 10px",
      color: theme.iconColor,
    },
  },
  search: {
    position: "relative",
    marginRight: 10,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.AppBGColor, 0.25),
    "&:hover": {
      backgroundColor: fade(theme.HeaderBGColor, 0.15),
    },
    marginLeft: 0,
    marginTop: 2,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing.unit,
      width: "auto",
    },
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
    height: 30,
    fontSize: 14,
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transitionDelay: "0.1s",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200,
      },
    },
  },

  "@keyframes activateSavebtn": {
    "0%": {
      transform: "scale(1.0)",
    },
    "50%": {
      transform: "scale(1.4)",
    },
    "100%": {
      transform: "scale(1.0)",
    },
  },
  saveIconEnabled: {
    cursor: "pointer",
    color: theme.HeaderSelectedText,
    "& svg": {
      animation: "activateSavebtn 2s ease-in-out 0s infinite forwards",
    },
  },
  saveIconDisabled: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  showHeader: {
    display: "block",
  },
  hideHeader: {
    display: "none",
  },
  editControls: {
    "&>div": {
      float: "left",
    },
  },
  showEditMode: {
    "&>div:before,&>div:after": {
      content: "none",
    },
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  tspEnabledIcon: {
    color: theme.HeaderSelectedText,
  },
  fieldRoot: {
    color: theme.TextColor,
    borderBottom: `1px solid ${theme.iconColor}`,
    lineHeight: "normal",
  },
  iconStyle: {
    cursor: "pointer",
    color: theme.iconColor,
  },
  pickupsFilterDropdownIconStyle: {
    cursor: "pointer",
    color: theme.iconColor,
    marginRight: 4,
    marginTop: 3,
    fontSize: 18,
  },
  button: {
    minHeight: 24,
    fontSize: theme.textFontSize,
    padding: 0,
    textTransform: "none",
    "&$buttonDisabled": {
      borderColor: theme.HeaderSelectedText,
      cursor: "not-allowed",
    },
  },
  buttonDisabled: {},
  paperStyle: {
    backgroundColor: theme.ModalBGColor,
    marginTop: "40px",
  },
  menuItem: {
    paddingTop: "5px",
    paddingBottom: "5px",
    color: theme.TextColor,
    fontSize: theme.textFontSize,
  },
  selectedColorText: {
    color: theme.HeaderSelectedText,
  },
  inputStyle: {
    maxWidth: "100%",
    marginRight: 10,
    height: 26,
  },
  reactSelect: {
    marginRight: 10,
    "& .select__control": {
      minWidth: 100,
      backgroundColor: "transparent",
      minHeight: 24,
      maxHeight: 24,
      boxSizing: "border-box",
      marginTop: 6,
      borderRadius: 2,
      border: `1px solid ${theme.iconColor}`,
      fontSize: theme.textFontSize,
      cursor: "pointer",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        border: `1px solid ${theme.iconColor}`,
      },
      "& .select__value-container": {
        height: 24,
        color: theme.TextColor,
      },
      "& .select__single-value": {
        color: "inherit",
      },
      "& .select__indicators": {
        height: 24,
        "& .select__indicator": {
          padding: 5,
          height: 24,
        },
        "& .select__indicator-separator": {
          height: 24,
          margin: 0,
          display: "none",
        },
      },
    },
    "& .select__menu": {
      margin: 0,
      maxHeight: 140,
      border: `1px solid ${theme.iconColor}`,
      borderRadius: "0 0 2px 2px",
      borderTop: "none",
      "& .select__menu-list": {
        maxHeight: 139,
        borderRadius: 2,
        fontSize: theme.textFontSize,
        backgroundColor: theme.ModalBGColor,
        color: theme.TextColor,
      },
      "& .select__option--is-focused": {
        backgroundColor: theme.HighlightColor,
        cursor: "pointer",
      },
      "& .select__option--is-selected": {
        backgroundColor: theme.HeaderSelectedText,
      },
    },
  },
  fieldValue: {
    height: 30,
    fontSize: theme.textFontSize,
    maxWidth: 100,
    "&$inputUnderline": {
      "&:before, &:after, &:hover:before": {
        borderColor: theme.iconColor,
      },
    },
  },
  inputUnderline: {},
  fieldInput: {
    fontSize: theme.textFontSize,
    "&::placeholder": {
      color: theme.iconColor,
    },
  },
  actionIcon: {
    fontSize: "14px",
  },
  updateMessage: {
    float: "left",
    lineHeight: "30px",
    fontSize: 14,
    color: theme.HeaderSelectedText,
    paddingRight: "10px",
  },
  toggleText: {
    display: "inline-block",
    fontSize: "12px",
    color: theme.iconColor,
  },
  showControl: {
    display: "block",
    float: "left",
  },
  hideControl: {
    display: "none",
  },
  clearIcon: {
    paddingRight: "5px",
  },
  iconHidden: {
    visibility: "hidden",
  },
  iconVisible: {
    visibility: "visible",
    color: theme.iconColor,
    cursor: "pointer",
    paddingRight: "5px",
  },
  activeIcon: {
    color: theme.HeaderSelectedText,
  },
  pickupsFilterContainer: {
    marginRight: 8,
    marginTop: 3,
  },
});

export default styles;
